module.exports = __webpack_public_path__ + "img/germany-female.2d2ee0a4.png";